<template>
  <div>
    <div class="jumbotron">
      <h1>Mes recherches</h1>
      <h4>Retrouvez ici toutes vos recherches personnalisées que vous partagez ou non avec d'autres membres</h4>
    </div>
    <div class="container">
      <div
        class="list-group-item list-group-item-action search-list-item"
        v-for="search in searches"
        :key="search.searchId"
      >
        <router-link :to="{name: 'SearchDetails', params: {id: search.searchId}}">
          <div>
            <h3 class="search-title">{{search.name}}</h3>

            <div class="row">
              <div class="col-4 icon-container">
                <span class="icon fas fa-users"></span>
                {{(search.nbUsers + 1)}}
              </div>
              <div class="col-4 icon-container">
                <span class="icon fas fa-clipboard-list"></span>
                {{search.nbItems}}
              </div>
              <div class="col-4 icon-container">
                <span class="icon fas fa-star"></span>
                {{search.nbItems}}
              </div>
            </div>
          </div>
        </router-link>
        <button class="side-delete" @click="deleteSearch(search)">
          <span class="icon fas fa-trash-alt" v-show="!search.deleting"></span>
          <div class="spinner-border text-primary" role="status" v-show="search.deleting"></div>
        </button>
      </div>

      <div class="spinner-border text-primary" role="status" v-show="status.loading">
        <span class="sr-only">Mise à jour en cours...</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "SearchList",
  searches: null,
  data() {
    return {
      searches: [],
      status: { loading: false, errorMessage: null }
    };
  },
  mounted() {
    console.log("URL : " + process.env.BACKEND_URL);
    var vm = this;
    vm.status.loading = true;
    axios.get(process.env.BACKEND_URL + "/api/searches").then(response => {
      response.data.forEach(search => {
        search.deleting = false;
      });
      vm.searches = response.data;
      
      vm.status.loading = false;
    });
  },
  methods: {
    deleteSearch: function(search) {
      var vm = this;
      search.deleting = true;
      // vm.searches[index].deleting = true;
      axios
        .delete(process.env.BACKEND_URL + "/api/searches/" + search.searchId)
        .then(response => {
          search.deleting = false;
          var index = vm.searches.indexOf(search);
          vm.searches.splice(index, 1);
        }).catch(error => {
          search.deleting = false;
        });
    }
  }
};
</script>

<style scope>
.list-group-item:first-child {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.search-list-item {
  display: block;
  text-decoration: none;
  background: #1a252f;
  color: #fff;
  border-radius: 0;
  border: 0;
  margin-bottom: 5px;
  /* color: #2c3e50; */
  /* background: #1abc9c; */
}

.search-list-item:hover {
  background: #2c3e50;
  color: #fff;
  /* border-radius: 10px; */
}

.search-list-item a:hover {
  text-decoration: none;
}

.search-list-item h3 {
  font-weight: bold;
  color: white;
}

.search-list-item .icon-container {
  color: #1abc9c;
}

.side-delete {
  position: absolute;
  top: 0;
  right: 0;
  background: #dd3d31;
  height: 100%;
  width: 60px;
  line-height: 90px;
  vertical-align: middle;
  border-style: none;
}

.side-delete .icon {
  color: #fff;
}

.side-delete .spinner-border {
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/SearchList.vue